import Api from '../Api';

export const getRacks = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/racknos');
  dispatch({
    type: 'FETCH_RACKS',
    payload: data,
  });
};

export const clearRacks = () => {
  return {
    type: 'CLEAR_RACKS',
  };
};

export const getRack = id => async dispatch => {
  const { data } = await Api.get(`/dropdowns/racknos/${id}`);
  dispatch({
    type: 'FETCH_RACK',
    payload: data,
  });
};

export const clearRack = () => {
  return {
    type: 'CLEAR_RACK',
  };
};

export const getRackIds = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/racknos/ids');
  dispatch({
    type: 'FETCH_RACK_IDS',
    payload: data,
  });
};

export const clearRackIds = () => {
  return {
    type: 'CLEAR_RACK_IDS',
  };
};
